<!-- <h1 mat-dialog-title>Comments</h1>
<div mat-dialog-content>
  <table mat-table [dataSource]="data" class="mat-elevation-z8">
    <ng-container matColumnDef="empId">
      <th mat-header-cell *matHeaderCellDef> Employee ID </th>
      <td mat-cell *matCellDef="let element"> {{ element.empId }} </td>
    </ng-container>

    <ng-container matColumnDef="managerId">
      <th mat-header-cell *matHeaderCellDef> Manager ID </th>
      <td mat-cell *matCellDef="let element"> {{ element.managerId }} </td>
    </ng-container>

    <ng-container matColumnDef="comments">
      <th mat-header-cell *matHeaderCellDef> Comments </th>
      <td mat-cell *matCellDef="let element"> {{ element.comments }} </td>
    </ng-container>

    <ng-container matColumnDef="actionDate">
      <th mat-header-cell *matHeaderCellDef> Action Date </th>
      <td mat-cell *matCellDef="let element"> {{ element.actionDate | date }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
</div> -->

<h1>Warning Dialog</h1>

<div class="table-container">
  <table>
    <tr>
      <th>Employee ID</th>
      <th>Manager ID</th>
      <th>Comments</th>
      <th>Action Date</th>
    </tr>
    <tr *ngFor="let item of data.data">
      <td>{{ item.empId }}</td>
      <td>{{ item.managerId }}</td>
      <td>{{ item.comments }}</td>
      <td>{{ item.actionDate | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
    </tr>
  </table>
</div>
<button class="close-btn" (click)="closeDialog()">Close</button>


